// extracted by mini-css-extract-plugin
export default {"modalContent":"AddPickUpPointModal_modalContent__hW-Tl"};